import publicConfig from "../../public-config.js";

const normalizeBaseUrl = () => {
  const url = publicConfig.external_address;
  if (!url) {
    return window.location.origin;
  }
  if (!/^https?:\/\//i.test(url)) {
    return `https://${url}`;
  }
  return url;
};

export const buildUrl = async (endpoint, params = null, query = null) => {
  const baseUrl = normalizeBaseUrl();
  let updatedEndpoint = endpoint;

  if (null !== params) {
    Object.keys(params).forEach((key) => {
      updatedEndpoint = updatedEndpoint.replace(`:${key}`, params[key]);
    });
  }

  const url = new URL(updatedEndpoint, baseUrl);

  if (null !== query) {
    Object.entries(query).forEach(([name, value]) => {
      if (null === value || value === undefined) return;

      if (Array.isArray(value)) {
        value.forEach((currentValue) => {
          url.searchParams.append(name, currentValue);
        });
      } else {
        url.searchParams.append(name, value);
      }
    });
  }

  return url.href;
};
